import React from 'react';
import './Logo.css';

const Logo = ({ containerStyle = '', svgStyle = '' }) => {
  return (
    <div 
    // className={`${containerClass}`} 
      style={containerStyle}>
      <svg
        // className={`${svgClass}`}
        style={svgStyle}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="logoTitle"
        role="img"
      >
        <title id="logoTitle">Right-Oriented Connected Nodes Logo</title>

        {/* Lines connecting the nodes */}
        <line x1="70" y1="30" x2="30" y2="50" stroke="#00AEEF" strokeWidth="6" />
        <line x1="30" y1="50" x2="60" y2="80" stroke="#00AEEF" strokeWidth="6" />

        {/* Circles (nodes) */}
        <circle cx="70" cy="30" r="14" fill="#fff" stroke="#00AEEF" strokeWidth="6" />
        <circle cx="30" cy="50" r="10" fill="#fff" stroke="#00AEEF" strokeWidth="5" />
        <circle cx="60" cy="80" r="10" fill="#fff" stroke="#00AEEF" strokeWidth="6" />
      </svg>
    </div>
  );
};

export default Logo;
